//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: ['competition', 'sport'],
  data() {
    return {
      competitions: [],
      events: [],
      defaultFilter: null,
      selectedFilter: null,
      hiddenEvents: [],
      filters: [],
      loading: true,
      marketCount: 0
    }
  },
  computed: {
    hash() {
      return `${this.competition}|${this.region}|${this.sport}`
    }
  },
  watch: {
    hash: {
      handler: function (newVal, oldVal) {
        this.loading = true
        this.fetchEvents()
      }
    }
  },
  mounted() {
    this.loading = true
    this.fetchEvents()
  },
  methods: {
    async toggleEvent(eventId) {
      if(_.size(this.events) <= 1) {
        return false;
      }
      this.hiddenEvents = _.xor(this.hiddenEvents, [eventId])
    },
    async fetchEvents() {
      let params = {}
      params['sport'] = this.sport
      params['limit'] = 3
      params['lang'] = this.lang;
      if (this.competition) {
        params['competition'] = this.competition
      }
      if (this.eventId) {
        params['event_id'] = this.eventId
        params['market_id'] = this.marketId
        params['limit'] = null
      }
      //params['region'] = this.region
      console.log('outrights', params);
      params.bookmaker = process.env.BOOKMAKER
      console.log('find outrights', new URLSearchParams(params).toString())
      let cacheKey = 'find_outrights_' + new URLSearchParams(params).toString()
      try {
        let response = await this.$cache().getItem(cacheKey)
        if(response) {
          this.initHidden(response.events)
          this.events = response.events
          this.loading = false
          this.marketCount = response.market_count
        }
      } catch (e) {}

      this.$socket().send('find', 'outrights', params, (error, response) => {
        console.log('response', response);
        this.$cache().setItem(cacheKey, response)

        this.$emit('title', _.get(response, 'events.0.markets.0.name'))
        this.initHidden(response.events)

        this.events = response.events
        this.loading = false
        this.marketCount = response.market_count
      })
    },
    initHidden(events) {
      if(this.loading && _.size(events) > 1 && _.isArray(events)) {
        _.each(events,  event => {
          if(_.size(event.markets) > 10) {
            this.hiddenEvents = _.xor(this.hiddenEvents, [event.id])
          }
        })
      }
    }
  }
}
